import { createAsyncThunk } from '@reduxjs/toolkit';
import { VehicleServicesService } from '../../../epics/common/commonData';
import {
    nameServicesKey,
    typeServicesKey,
} from '../thunkKeys/servicesThunksKeys';

export const getNameServices = createAsyncThunk(
    nameServicesKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehicleServicesService.getNameServices();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getTypeServices = createAsyncThunk(
    typeServicesKey,
    async (_, thunkAPI) => {
        try {
            const response = await VehicleServicesService.getTypeServices();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);
